import angular from 'angular';

import serviceModule from '../../services/service.module';
import apiModule from '../../api/api.module';

import { ChartDateFilter, ChartLabelFilter } from './chart.filter';
import GetIndexOfFilter from './getIndexOf.filter';
import LimitObjectFromToFilter from './limitObjectTo.filter';
import ObjectKeysLengthFilter from './objectKeysLength.filter';
import SearchFormatFilter from './attrs.searchformat.filter';
import { urlMarkDown, urlTextMarkdown } from './url.filter';
import WithOutNullFilter from './withoutNull.filter';

const equipmentFilterModule = angular.module('app.equipmentFilters', [serviceModule, apiModule]);

equipmentFilterModule
	.filter('ChartDateFilter', ChartDateFilter)
	.filter('ChartLabelFilter', ChartLabelFilter)
	.filter('getIndexOf', GetIndexOfFilter)
	.filter('limitObjectFromTo', LimitObjectFromToFilter)
	.filter('objectKeysLength', ObjectKeysLengthFilter)
	.filter('searchFormat', SearchFormatFilter)
	.filter('withoutNull', WithOutNullFilter)
	.filter('urlMarkdown', urlMarkDown)
	.filter('urlTextMarkdown', urlTextMarkdown);

export default equipmentFilterModule.name;
